/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Wine(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M200.402,106.66714l1.65622,5.61085a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835l3.54259-12.00146h0C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713Z"
        opacity={0.2}
      />
      <Line
        x1={128}
        y1={176}
        x2={128}
        y2={232}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={88}
        y1={232}
        x2={168}
        y2={232}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Wine;
